import React, {PropTypes} from "react";
import {connect} from "react-redux";
import RequestAccessForm from './components/RequestAccessAppAutoComplete';
import RequestModal from './components/RequestModal';
import ApplicationsTable from './components/ApplicationsTable';
import axios from 'axios';
import toastr from "toastr";

class MyApplicationHome extends React.Component {

  constructor() {
    super();
    this.state = ({myApplications: null,openRequestModal: false,selected: false,applicationSelected: null});
    this.onRequestAccess = this.onRequestAccess.bind(this);
    this.getPendingAndCurrentApplications = this.getPendingAndCurrentApplications.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.setState({selected: false});
  }

  onRequestAccess(applicationName) {
    console.log("INSIDE APP HOME");
    // find selected application details using application name
    console.log(applicationName);
    let applicationSelected = null
    applicationSelected = this.props.applications.find((node)=>{
      console.log(node);
      return node.appName == applicationName;
    });
    console.log(applicationSelected.id);

    //check if any pending or approved application exists for selected application
    let applicationExists = this.state.myApplications!=null?this.state.myApplications.find((node)=>{
      return ((applicationSelected.id == node.appID && (node.managerStatus == "Pending" )) || (applicationSelected.id == node.appID && (node.vhPermission == 0 && node.managerStatus == "Approved" && node.ownerStatus == "Pending")) || (applicationSelected.id == node.appID && (node.vhPermission == 0 && node.managerStatus == "Approved" && node.ownerStatus == "Approved")) || (applicationSelected.id == node.appID && (node.vhPermission == 1 && node.managerStatus == "Approved" && node.vhStatus == "Pending")) || (applicationSelected.id == node.appID && (node.vhPermission == 1 && node.managerStatus == "Approved" && node.vhStatus == "Approved" && node.ownerStatus == "Pending")) || (applicationSelected.id == node.appID && (node.vhPermission == 1 && node.managerStatus == "Approved" && node.vhStatus == "Approved" && node.ownerStatus == "Approved")));
    }):null;
    // if no existing application found, open Modal and send application details as props to it
    if(applicationExists == undefined || applicationExists == null) {
      this.setState({selected: true, applicationSelected: applicationSelected})
    }
    else {
      // else show toastr error that application already exists
      toastr.error("Application already exists in pending or approved state!");
    }
  }

  getPendingAndCurrentApplications() {
    //MAKE THE API CALL
    let request = {
      empId: this.props.empID,
      managerStatus: 0,
      vhStatus : 0,
      ownerStatus: 0,
    }
    axios.get(process.env.REQ_URL + "/appaccess/getAllAccessApplications?q="+ JSON.stringify(request), {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let myApplications = response.data.data;
      this.setState({myApplications: myApplications});
    }).catch((err)=> {
    });
  }

  componentDidMount() {
    //MAKE API CALL TO GET MY APPLICATIONS
    this.getPendingAndCurrentApplications();
    this.props.changeBanner("My Applications");
  }

  render() {
    console.log(this.props);
    return (
      <div>
        <RequestAccessForm
          onRequestAccess={this.onRequestAccess}
          applications={this.props.applications}
        />
        {this.state.selected?
          <RequestModal
            applicationSelected={this.state.applicationSelected}
            refresh={this.getPendingAndCurrentApplications}
            empID={this.props.empID}
            reportingToName={this.props.reportingToName}
            reportingTo={this.props.reportingTo}
            verticalHead={this.props.verticalHead}
            verticalHeadName={this.props.verticalHeadName}
            open={this.state.selected}
            close={this.closeModal}
          />:null
        }
        {this.state.myApplications!=null?<ApplicationsTable data={this.state.myApplications}/>:null}
      </div>
    );
  }
}

export default (MyApplicationHome);



/** WEBPACK FOOTER **
 ** ./src/feature/appAccess/MyApplications/MyApplicationHome.js
 **/